// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"SitemapPage_pageTitle__7987a","staticPageWrapper":"SitemapPage_staticPageWrapper__6qe3J","title":"SitemapPage_title__1m7mi","text":"SitemapPage_text__2Y51U"};